import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema, toParagraphContent } from '@principle-theorem/editor';

const reviewCount = 10;

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/charting/multi-treatments'],
  validationMode: 'count',
  requiredCount: reviewCount,
};

export const multiTreatmentsSetupStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.MultiTreatmentsSetup,
  category: PracticeSetupStepCategory.ConditionsAndTreatments,
  title: 'Review and Configure Multi-Treatments',
  description: initRawSchema([
    toParagraphContent(
      `Multi treatments are procedures that require more than one appointment to complete, or are completed in a single appointment with multiple treatments. Common examples include Crowns, Bridges, or Invisalign, where the overall treatment is made up of a series of distinct steps, each taking place across separate visits. Multi Treatments are closely linked to your Treatments setup.`
    ),
    toParagraphContent(
      `Before reviewing your Multi-Treatment configurations, ensure that your individual treatments have already been reviewed and finalised, as Treatment Steps within a Multi Treatment will draw from these.`
    ),
  ]),
  dependsOn: [PracticeSetupStepId.TreatmentsSetup],
  getRoute: (brand, _practice) =>
    `settings/brand/${brand.ref.id}/charting/multi-treatments`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason: `Please review and approve at least ${reviewCount} multi-treatments before completing this step`,
        };
      })
    );
  },
  pageVisitTracking,
};
